import { Category } from '~/models/Category';
import { Topic } from '~/models/Topic';

export function selectArticlesSitemap(props) {
  return {
    categories: props.categories.map(cat => (cat?.content?.component === 'topic' ? new Topic(cat) : new Category(cat))),
    sitemap: props.sitemap,
  };
}
